import { render, staticRenderFns } from "./GamerGuide.vue?vue&type=template&id=4a538a1a&scoped=true"
import script from "./GamerGuide.vue?vue&type=script&lang=ts"
export * from "./GamerGuide.vue?vue&type=script&lang=ts"
import style0 from "./GamerGuide.vue?vue&type=style&index=0&id=4a538a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a538a1a",
  null
  
)

export default component.exports